/**
 * Created by Pradeep Kumar on 05/20/2019.
 */

import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {NoWinSymbolsWinPresentationController} from "@nolimitcity/slot-game/bin/game/winpresentation/nowinsymbols/NoWinSymbolsWinPresentationController";
import {IBetLineWinData, IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {TombOfNefertitiParsedGameData} from "../../server/data/TombOfNefertitiParsedGameData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TombOfNefertitiParsedInitData} from "../../server/data/TombOfNefertitiParsedInitData";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class TombOfNefertitiNoWinSymbolsWinPresentationController extends NoWinSymbolsWinPresentationController {
    private respinReels: boolean[];
    private nextMode: string = "";
    private _isRestoreState: boolean = false;

    protected getBetLineSymbolWinStates(): void {
        const numOfRows = 3,
            symId = 0;

        this._betWinsData!.forEach((betWinData: IBetWinData) => {
            const betLineWinData:IBetLineWinData = <IBetLineWinData>betWinData;
            for (let reelId: number = 0; reelId < betLineWinData.nrOfSymbols; reelId++) {
                const symbolId: number = betLineWinData.betLine[reelId];
                this._symbolWinStates[(reelId * numOfRows) + symbolId][symId] = true; // overridden here to work as per 15 reels.
                this.updateStackedSymbolWinStates(reelId, symbolId);
            }
        });
    }

    protected parseFeatureGameData(data: TombOfNefertitiParsedGameData): void {
        super.parseFeatureGameData(data);
        this.nextMode = data.nextGameMode;
        this.respinReels = data.respinPositions ? data.respinPositions.reduce((acc, currEl) => acc.concat(<any>currEl), []) : []; // need to type cast it as this reduce will not work directly on boolean.
    }

    protected addFeatureEventHandlers(): void {
        super.addFeatureEventHandlers();

        EventHandler.addEventListener(this, SpinEvent.STOPPED, () => this.normalizeAllSymbols());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onParsedInitData(event.params[0]));

        // #330 fix
        EventHandler.addEventListener(this, GameModeEvent.CHANGE_MODE, (event: GameEvent) => {
            if(event.params[0].newMode === GameMode.NORMAL) {
                this.normalizeAllSymbols();
            }
        });
    }

    // we don't want super's call
    protected onBeforeSpinStart(): void {
        if (this._isRestoreState) {
            this.respinReels = this.respinReels ? this.respinReels.reduce((acc, currEl) => acc.concat(<any>currEl), []) : [];
            this.stopWinPresentation(false, true);
            this._isRestoreState = false;
        }

        while (this._noWinSymbols.length > 0) {
            const symbol: StateReelSymbol = this._noWinSymbols.pop()!;
            if (this.respinReels[symbol.reelId]) {
                symbol.changeState({
                    state: GameConfig.instance.SYMBOL_STATES.normal,
                    fadeInDuration: 0
                });
            }
        }
    }

    protected stopWinPresentation(isAborted: boolean, isRestore?: boolean): void {
        // If abort before running this wp, we don't need to reset no win symbols.
        if (isAborted) {
            return;
        }

        let noWinSymbol: StateReelSymbol | null;
        for (let i: number = 0; i < this.respinReels.length; i++) {
            if (!isRestore) {
                if (this._symbolWinStates[i][0]) {
                    continue;
                }
            }
            else {
                if (this.respinReels[i]) {
                    continue;
                }
            }

            noWinSymbol = Reels.getSymbol(i, 0);
            if (noWinSymbol == null || (noWinSymbol.symName === "W" && this.nextMode.indexOf('RESPIN') !== -1)) { // overridden here for #139 (keeping wild in normal state during re spins)
                continue;
            }

            (noWinSymbol as any)._stateAnimations = {}; // #251 fix
            noWinSymbol.changeState({
                state: GameConfig.instance.SYMBOL_STATES.noWin!,
                fadeInDuration: this._noWinConfig.noWinStateFadeInDuration
            });
            this._noWinSymbols.push(noWinSymbol);
        }
    }

    private normalizeAllSymbols(): void {
        if (this.nextMode.indexOf('RESPIN') === -1) {
            for (let i: number = 0; i < 15; i++) {
                let symbol = Reels.getSymbol(i, 0);
                symbol!.changeState({
                    state: GameConfig.instance.SYMBOL_STATES.normal,
                    fadeInDuration: 0
                });
            }
        }
    }

    private onParsedInitData(data: TombOfNefertitiParsedInitData): void {
        this.respinReels = data.respinPositions;
        this._isRestoreState = data.isRestoreState;
        this.nextMode = data.nextMode;
    }
}